import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import customerRoutes from "./customerRoutes";
import vendorRoutes from "./vendorRoutes";
import customerAuthRoutes from "./customerAuthRoutes";
import vendorAuthRoutes from "./vendorAuthRoutes";
import NotFound from "../components/NotFoundRedirect";
import VendorAuthLayout from "@/layouts/AuthLayout";
import NotFoundRedirect from "../components/NotFoundRedirect";
import HomePage from "@/modules/home";
import TermsOfService from "@/modules/vendor/pages/PrivacyPolicy/TermsOfService";
import PrivacyPolicy from "@/modules/vendor/pages/PrivacyPolicy/PrivacyPolicy";
import Subscription from "@/modules/customer/components/Subscription";
import FAQsPage from "@/modules/customer/components/FAQ/faqpage";
import AboutUs from "@/modules/vendor/pages/PrivacyPolicy/AboutUs";

const AppRoutes = () => {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const role = localStorage.getItem("role");

  return (
    <Router>
      <Routes>
        {/* Customer Auth Routes */}

        {customerAuthRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {/* Nested Customer Auth Routes */}
            {route.children &&
              route.children.map((child, i) => (
                <Route key={i} path={child.path} element={child.element} />
              ))}
          </Route>
        ))}

          {vendorAuthRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {/* Nested Vendor Auth Routes */}
            {route.children &&
              route.children.map((child, i) => (
                <Route key={i} path={child.path} element={child.element} />
              ))}
          </Route>
        ))}

        {/* Protected Customer Routes */}
        {customerRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<ProtectedRoute>{route.element}</ProtectedRoute>}
          >
            {route.children &&
              route.children.map((child, i) => (
                <Route key={i} path={child.path} element={<ProtectedRoute>{child.element}</ProtectedRoute>} />
              ))}
          </Route>
        ))}

        {/* Protected Vendor Routes */}
        {vendorRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
          >
            {route.children &&
              route.children.map((child, i) => (
                <Route key={i} path={child.path} element={<ProtectedRoute>{child.element}</ProtectedRoute>} />
              ))}
          </Route>
        ))}

        {/* Default Route Based on Role */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              // <Navigate to={role === "vendor" ? "/vendor/dashboard" : "/customer/search-brokers"} replace />
              <HomePage></HomePage>
            ) : (
              <HomePage></HomePage>
            )
          }
        />

        {/* 404 Route */}
        <Route path="*" element={<NotFoundRedirect />} />

        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/faqs" element={<FAQsPage />} />

        <Route path="/subscription" element={<Subscription />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
